var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2092 13.0608C19.9342 12.9797 20.3632 12.9797 21.1422 13.0608C22.5212 13.2648 23.7995 13.9022 24.7922 14.8808C24.1214 15.5149 23.4593 16.1583 22.8062 16.8107C21.5556 15.7507 20.1596 15.5061 18.6182 16.0768C17.4876 16.5968 16.7002 17.4394 16.2562 18.6048C15.5307 18.0646 14.8146 17.5118 14.1082 16.9467C14.0592 16.9209 14.0031 16.9115 13.9482 16.9197C15.0702 14.7564 16.8236 13.4697 19.2082 13.0597",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9463 16.9212C14.0029 16.9125 14.0566 16.9215 14.1073 16.9482C14.8136 17.5132 15.5297 18.066 16.2553 18.6062C16.1411 19.0602 16.0691 19.5239 16.0403 19.9912C16.0649 20.4432 16.1366 20.8868 16.2553 21.3222L14.0003 23.1172C13.0183 21.0652 13.0003 18.9998 13.9463 16.9212Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6851 25.2907C23.9829 24.6715 23.2479 24.0907 22.4831 23.5507C23.2497 23.0094 23.7151 22.2667 23.8791 21.3227H20.1221V18.7137C22.2887 18.6957 24.4544 18.7141 26.6191 18.7687C27.0297 20.9987 26.5554 23.0094 25.1961 24.8007C25.0344 24.9725 24.8632 25.1361 24.6851 25.2907Z",
    fill: "#448AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.255 21.3203C17.075 23.3583 18.5783 24.3096 20.765 24.1743C21.3788 24.1033 21.9673 23.8888 22.483 23.5483C23.2483 24.0896 23.9823 24.6696 24.685 25.2883C23.5716 26.2888 22.1521 26.8824 20.658 26.9723C20.3185 26.9994 19.9775 26.9994 19.638 26.9723C17.0927 26.6723 15.2133 25.3863 14 23.1143L16.255 21.3203Z",
    fill: "#43A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.552dbcc7a0f545b5e48eabea2beec580.svg";
export { ForwardRef as ReactComponent };